import { LoadingButton } from '@mui/lab';
import styled, { css } from 'styled-components';
import SyncIcon from '@mui/icons-material/Sync';

export const LoadingIcon = styled(SyncIcon)`
  @keyframes rotating {
    from {
      transform: rotate(359deg);
    }
    to {
      transform: rotate(0deg);
    }
  }

  animation: rotating 1s linear infinite;
`;

export const StyledLoadingButton = styled(LoadingButton)<{ $maxWidth?: string }>`
  height: 31px;
  font-weight: 700;
  font-size: 12px;
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth};

  ${({ loading }) =>
    loading &&
    css`
      &.Mui-disabled {
        background-color: ${({ theme: { palette } }) => palette.grey[200]};
      }
    `}
`;
